import React, { useEffect, useState } from 'react';
import ButtonModal from '@components/common/Button';
import BadgesComponent from '@components/common/Badges';
import Card from 'react-bootstrap/Card';
import './HRPTracking.css';
import CommonModal from '../../../../components/common/CommonModal';
import PlusSvgIcon from '../../../../assets/svg/plus.svg';
import endpoints from '@config/endpoints';
import { getData, postDataJSON } from '@services/CommonApiService';
import HRPHistory from './HRPHistory';
import AllHRPForms from './AllHRPForms';
import {
  ObstetricHistoryCheck,
  RoutineANCCondition,
  isValueContainsOnlyDigits,
} from '../../../../utils/hrpConditionCheck';
import HRPWarningModal from './HRPWarningModal';
import Clock from '../../../../assets/svg_main/clock-01.svg';
import { useLocation } from 'react-router-dom';
import Spinner from '@components/common/Spinner';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import FormatDate from '@utils/dateFormat';
import { getOngoingANCNumber } from '@utils/commonUtils';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import data from './HrpConditinList.json';
import config from '@config/config';
import { setBeneficiaryPregnancyHistory, setCheckIsHrp, setPregnancyDetails } from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';
import { COMMON_CONSTANTS, COMMON_FIELD_NAME } from '@constants/index';
import HRPFacilityDetails from './FacilityDetails';
import {  buttonNames, HRP_ERROR_MESSAGES } from '@constants/appConstants';
import { ANC_SUB_SERVICE } from '@constants/ancConstants';


const HRPConditionList = data.conditionList;
const HRPConditionsDisable = data.conditionDisable;
const ObsetricHistoryReportName = data.reportName;

const HRPTracking = () => {
  const { state } = useLocation();
  const [beneficiary, setBeneficiary] = useState(JSON.parse(state));
  const [showHRPConditionModal, setShowHRPConditionModal] =
    useState<boolean>(false);
  const [showHRPConditionForm, setShowHRPConditionForm] =
    useState<boolean>(false);
  const [selectHRPType, setSelectHRPType] = useState<any>(null);
  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [showFacilityDetails, setShowFacilityDetails] = useState<boolean>(false);
  const [facilityDetails, setFacilityDetails] = useState<any>();
  const checkIsHRP = useSelector((state: RootState) => state.beneficiary.checkIsHRP);
  const [selectedHrpData, setSelectedHrpData] = useState<any>(null);
  const [hrpConditionList, setHrpConditionList] =
    useState<any>(HRPConditionList);
  const [hrpFormData, setHrpFormData] = useState<any>(null);
  const [hrpServiceData, setHrpServiceData] = useState<any>(null);
  const [hrpConditionsData, setHrpConditionsData] = useState<any>([]);
  const [hrpConditionDisableList, setHrpConditionDisableList] = useState<any>(
    [],
  );
  const [hrpObsetricHistoryDisableList, setHrpObsetricHistoryDisableList] =
    useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [onGoingPregnancyData, setOnGoingPregnancyData] = useState<any>(null);
  const benfDetails = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryDetails,
  );
  const benefId = benfDetails?.[0]?.benef_id;
  const dispatch=useDispatch()
  const pregnancyId = useSelector(
    (state: RootState) => state.beneficiary.currPregnancyId);
  const userRole = benfDetails?.user_role || localStorage.getItem('userTypeName');

  const beneficiaryPregnancyHistory = useSelector(
      (state: RootState) => state.beneficiary.beneficiaryPregnancyHistory,
    );
  const benefPregnancyDetails = useSelector(
      (state: RootState) => state.beneficiary.pregnancyDetails,
    );

  const getBeneficiaryHRPCondtionsDetails = async (pregnancyId: any) => {
    if (!pregnancyId) return false;
    setIsLoading(true);
    await getData<any>(
      `${endpoints.getBeneficiaryHRPCondtionsDetails}/${benefId}/${pregnancyId}`,
    )
      .then((res) => {
        setHrpConditionsData(res?.data);
      })
      .catch((error) => {
        toast.error(error?.message, {
          position: 'top-center',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBeneficiaryHRPCondtionsDetails(onGoingPregnancyData?.pregnancyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onGoingPregnancyData]);

  useEffect(() => {
    const temphrpConditionsData = hrpConditionsData?.map((item: any) => {
        if (HRPConditionsDisable.includes(item.hrp_name)) {
          return item.hrp_name;
        } else if (item.treatment_status_code[0] !== "treated") {
          return item.hrp_name;
        }
      });
    const hrpConditionsList: any[] = [...temphrpConditionsData, ...hrpConditionDisableList]
    setHrpConditionDisableList(hrpConditionsList);
    setHrpObsetricHistoryDisableList(
      hrpConditionsData.map((item: any) => {
        if (ObsetricHistoryReportName.includes(item.hrp_name)) {
          return item.hrp_name;
        }
      }),
    );
  }, [hrpConditionsData]);

  const getOngoingPregnancyDetails = async (pregnancyId: any) => {
    try {
      const ongoingPregnancyDetails: any = benefPregnancyDetails?.data?.length > 0 ? benefPregnancyDetails : await getData(
        `${endpoints?.getPregnancyDetailsById}/${pregnancyId}`,
      );
      dispatch(setPregnancyDetails(ongoingPregnancyDetails));
      return ongoingPregnancyDetails;
    } catch (error: any) {
      toast.error(error?.message, {
        position: 'top-center',
      });
    }
  };

  const getPregnancyHistory = async () => {
    setIsLoading(true);
    try {
      const isBeneficiaryHistoryStored = beneficiaryPregnancyHistory?.data?.length > 0;
      const pregnancyDetails: any = isBeneficiaryHistoryStored ? beneficiaryPregnancyHistory : await getData(
        `${endpoints?.getPregnancyHistory(benefId)}`,
      );
      dispatch(setBeneficiaryPregnancyHistory(pregnancyDetails));
      const onGoingPregnancy = pregnancyDetails.data.find(
        (data: any) => data.delivery_status === 'on going',
      );
      if (
        onGoingPregnancy &&
        onGoingPregnancy.delivery_status === 'on going'
      ) {
        const ongoingPregnancyDetails = onGoingPregnancy?.pregnancy_id ? await getOngoingPregnancyDetails(
          onGoingPregnancy?.pregnancy_id,
        ) : null;
        if (ongoingPregnancyDetails?.is_first_preg) {
          const hrpConditionsDisableList: any[] = [...hrpConditionDisableList, 'Obstetric History'];
          setHrpConditionDisableList(hrpConditionsDisableList);
        }
        setOnGoingPregnancyData({
          ...ongoingPregnancyDetails,
          pregnancyId: onGoingPregnancy?.pregnancy_id,
        });
        setIsLoading(false);
      }
    } catch (error: any) {
      toast.error(error?.message, {
        position: 'top-center',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPregnancyHistory();
  }, []);

  const handleRowClick = async (hrpCondition: any) => {
    try {
      setIsLoading(true);
      const payload = {
        benefId: benefId,
        serviceId: hrpCondition?.service_id,
        hrpGroupCode: hrpCondition?.hrp_group_code,
      }
      const resposeData: any = await postDataJSON<any>(`${endpoints.getBeneficiaryHRPHistory}`,payload).then((res: any) => res.data);
      hrpCondition.hrp_name == 'Hep - B' ? setSelectedHrpData({
        data: resposeData,
        hrp_name: 'Hepatitis B',
      }) : hrpCondition.hrp_name == 'TB' ? setSelectedHrpData({
        data: resposeData,
        hrp_name: 'Presumptive TB symptoms',
      }) :
        setSelectedHrpData({
          data: resposeData,
          hrp_name: hrpCondition.hrp_name,
        });
    } catch (error: any) {
      toast.error(error?.message, {
        position: 'top-center',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const createDropDownOption = (serviceData: any) => {
    const option = serviceData?.map((ele: any) => {
      return {
        value: ele.report_id,
        label: ele.report_name,
        code: ele.report_code,
      };
    });

    return option;
  };

  const createDropDownDefaultValue = (data: any, type: any) => {
    if (type === 'single') {
      return {
        value: data.report_id,
        label: data.report_name,
        code: data.report_code,
      };
    }
  };

  const handleFormsModal = (selectedHRPValue: any, serviceData: any) => {
    let formObject: any = {
      showDateField: true,
      isMultiple: false,
      dropDownoption: [],
      service_code: selectedHRPValue.hrp_code,
      hrp_name: selectedHRPValue.hrp_name,
    };
    if (selectedHRPValue.hrp_key === 'tb') {
      const filteredServiceData = serviceData?.filter(
        (ele: any) => ele.report_code == 'positive_for_presumptive_tb',
      );
      if (filteredServiceData?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'TB Test',
            keyName: 'tb_screening_test',
            value: createDropDownDefaultValue(filteredServiceData?.[0], 'single'),
            dropDownoption: createDropDownOption(filteredServiceData),
            service_code: 'tb_screening_test',
            isSingleDropdown: true,
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'tb_screening_test_date',
            value: '',
            service_code: 'tb_screening_test',
            showDateField: true,
            isDate: true,
            service_id: filteredServiceData?.[0]?.service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'hypothyroidism') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code == 'identified_as_hypothyroid',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Thyroid Test',
            keyName: 'thyroid_test',
            value: createDropDownDefaultValue(data[0], 'single'),
            dropDownoption: createDropDownOption(data),
            service_code: 'thyroid_test',
            isSingleDropdown: true,
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'tthyroid_test_date',
            value: '',
            service_code: 'thyroid_test',
            showDateField: true,
            isDate: true,
            service_id: data[0].service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'hepB') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code == 'reactive',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Hep B Test',
            keyName: 'hbsag_test',
            value: createDropDownDefaultValue(data[0], 'single'),
            dropDownoption: createDropDownOption(data),
            service_code: 'hbsag_test',
            isSingleDropdown: true,
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'hbsag_test_date',
            value: '',
            service_code: 'hbsag_test',
            showDateField: true,
            isDate: true,
            service_id: data[0].service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'hiv') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code == 'referred_to_confirmatory_facility',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'HIV Screening Test',
            keyName: 'hiv_screening_test',
            value: createDropDownDefaultValue(data[0], 'single'),
            dropDownoption: createDropDownOption(data),
            service_code: 'hiv_screening_test',
            isSingleDropdown: true,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'syphilis') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code == 'reactive',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Syphilis Test',
            keyName: 'syphilis_test',
            value: createDropDownDefaultValue(data[0], 'single'),
            dropDownoption: createDropDownOption(data),
            service_code: 'syphilis_test',
            isSingleDropdown: true,
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'syphilis_test_date',
            value: '',
            service_code: 'syphilis_test',
            showDateField: true,
            isDate: true,
            service_id: data[0].service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'malaria') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code == 'positive',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Rapid Malaria Test',
            keyName: 'rapid_malaria_test',
            value: createDropDownDefaultValue(data[0], 'single'),
            dropDownoption: createDropDownOption(data),
            service_code: 'rapid_malaria_test',
            isSingleDropdown: true,
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'rapid_malaria_test_date',
            value: '',
            service_code: 'rapid_malaria_test',
            showDateField: true,
            isDate: true,
            service_id: data[0].service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'fetalMalpresentation') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code !== 'normal',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Fetal Presentation Position',
            keyName: 'fetal_presentation_position',
            value: '',
            dropDownoption: createDropDownOption(data),
            isSingleDropdown: true,
            service_code: 'fetal_presentation_position',
            isMultiple: false,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'gestationalDiabetesMellitus') {
      const data = serviceData?.filter(
        (el: any) => el.report_code !== 'lt_140',
      );
      if (data?.length > 0) {
        const dropDownoption = createDropDownOption(data);

        const formData = {
          selectedHrp: {
            labelName: 'Gestational Diabetes Mellitus',
            keyName: 'ogtt_test',
            value: '',
            dropDownoption: dropDownoption,
            isSingleDropdown: true,
            service_code: 'ogtt_test',
          },
          showDateField: {
            labelName: 'Test Date',
            keyName: 'ogtt_test_date',
            value: '',
            service_code: 'ogtt_test',
            showDateField: true,
            isDate: true,
            service_id: data[0].service_id,
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'rhNegativeBloodGroup') {
      const data = serviceData?.filter(
        (ele: any) =>
          ele.report_code === 'a_negative' ||
          ele.report_code === 'b_negative' ||
          ele.report_code === 'ab_negative' ||
          ele.report_code === 'o_negative',
      );
      if (data?.length > 0) {
        const formData = {
          selectedHrp: {
            labelName: 'Blood Group',
            keyName: 'blood_group_and_rh_factor',
            value: '',
            dropDownoption: createDropDownOption(data),
            isMultiple: false,
            isSingleDropdown: true,
            service_code: 'blood_group_and_rh_factor',
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'otherHighRiskSymptoms') {
      const dropdownData: any = serviceData?.filter(
        (ele: any) =>
          ele.report_code === 'other_stirti' ||
          ele.report_code === 'high_fever',
      );
      if (dropdownData?.length > 0) {
        const data = {
          selectedHrp: {
            labelName: 'High Risk Symptoms',
            keyName: 'selectedHrp',
            value: '',
            dropDownoption: createDropDownOption(dropdownData),
            isMultiple: true,
          },
        };
        formObject = data;
      }
    } else if (selectedHRPValue.hrp_key === 'obstraticHistory') {
      const data = serviceData?.filter(
        (ele: any) => ele.report_code !== 'none_of_the_above' && ele.report_code !== 'ho_spontaneous_abortion_miscarraige',
      );
      if (data?.length > 0) {
        const dropDownoption = createDropDownOption(data);
        const formData = {
          selectedHrp: {
            labelName: 'Obstetric History',
            keyName: 'obstetric_history',
            value: '',
            dropDownoption: dropDownoption,
            isMultiple: true,
            service_code: 'obstetric_history',
          },
        };
        formObject = formData;
      }
    } else if (selectedHRPValue.hrp_key === 'hypertension') {
      const formData = {
        bp_systolic_mm_hg: {
          labelName: 'BP Systolic (mm Hg)',
          keyName: 'bp_systolic_mm_hg',
          value: '',
          inputType: true,
          service_code: 'bp_systolic_mm_hg',
          ...serviceData?.filter(
            (ele: any) => ele.service_code == 'bp_systolic_mm_hg',
          )[0],
        },
        bp_diastolic_mm_hg: {
          labelName: 'BP Diastolic (mm Hg)',
          keyName: 'bp_diastolic_mm_hg',
          value: '',
          inputType: true,
          service_code: 'bp_diastolic_mm_hg',
          ...serviceData?.filter(
            (ele: any) => ele.service_code == 'bp_diastolic_mm_hg',
          )[0],
        },
      };
      formObject = formData;
    } else if (selectedHRPValue.hrp_key === 'underWeight') {
      const formData = {
        weight_in_kg: {
          labelName: 'Weight (Kgs)',
          keyName: 'weight_in_kg',
          value: '',
          inputType: true,
          service_code: 'weight_in_kg',
          ...serviceData[0],
        },
      };
      formObject = formData;
    } else if (selectedHRPValue.hrp_key === 'shortStature') {
      const formData = {
        height_in_cm: {
          labelName: 'Height (Cm)',
          keyName: 'height_in_cm',
          value: '',
          inputType: true,
          service_code: 'height_in_cm',
          ...serviceData[0],
        },
      };
      formObject = formData;
    } else if (selectedHRPValue.hrp_key === 'severeAnemia') {
      const dropdownData = serviceData?.filter(
        (el: any) => el?.service_code == 'severe_anaemia_treatment',
      );
      const hbgm = serviceData?.find((el: any) => el?.service_code == 'hb_gm');
      const data = {
        hb_gm: {
          labelName: COMMON_FIELD_NAME.HB_DL,
          keyName: 'hb_gm',
          inputType: true,
          value: 1.0,
          showDateField: false,
          ...hbgm,
        },
        severe_anaemia_treatment: {
          labelName: 'Severe Anaemia Treatment',
          keyName: 'severe_anaemia_treatment',
          inputType: true,
          value: '',
          showDateField: false,
          dropDownoption: createDropDownOption(dropdownData),
          ...dropdownData[0],
          isSingleDropdown: true,
        },
      };

      formObject = data;
    }

    setHrpFormData(formObject);
    setShowHRPConditionForm(true);
    setShowHRPConditionModal(false);
  };

  const getServiceReportData = async (selectedHRPValue: any) => {
    setIsLoading(true);
    const payload = {
        serviceCode: selectedHRPValue?.hrp_code,
    }
    await postDataJSON<any>(`${endpoints.getMultipleServiceReport}`, payload)
      .then((res) => {
        if (res) {
          setHrpServiceData(res?.data);
          handleFormsModal(selectedHRPValue, res?.data);
        }
      })
      .catch((error) => {
        toast.error(error?.message, {
          position: 'top-center',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleHRPTypesClick = (selectedHRPValue: any): any => {
    if (hrpConditionDisableList.includes(selectedHRPValue.hrp_name)) {
      return;
    }

    setSelectHRPType(selectedHRPValue);
    getServiceReportData(selectedHRPValue);
  };

  const closeHRPConditionTypesModal = (data: string) => {
    if (data === 'yes') {
      setShowWarningModal(true);
    } else {
      setSelectHRPType(null);
      setHrpServiceData(null);
      setHrpFormData(null);
    }
    setShowHRPConditionForm(false);
  };

  const isHrpConditionFormNextBtnDisabled = () => {
    if (selectHRPType.hrp_key == 'hypertension') {
      if (
        hrpFormData?.bp_diastolic_mm_hg?.value &&
        hrpFormData?.bp_systolic_mm_hg?.value &&
        config.bpSystolicMax > parseInt(hrpFormData.bp_systolic_mm_hg.value) &&
        config.bpDiastolicMax > parseInt(hrpFormData.bp_diastolic_mm_hg.value) &&
        config.bpSystolicMin < parseInt(hrpFormData.bp_systolic_mm_hg.value) &&
        config.bpDiastolicMin < parseInt(hrpFormData.bp_diastolic_mm_hg.value) &&
        hrpFormData.bp_systolic_mm_hg.value > parseInt(hrpFormData.bp_diastolic_mm_hg.value) &&
        RoutineANCCondition(
          'isBpSystolicHRP',
          hrpFormData?.bp_systolic_mm_hg?.value,
        ) &&
        RoutineANCCondition(
          'isBpDiastolicHRP',
          hrpFormData?.bp_diastolic_mm_hg?.value,
        )
      ) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'severeAnemia') {
      if (
        hrpFormData?.hb_gm?.value &&
        RoutineANCCondition('hb', hrpFormData?.hb_gm?.value) &&
        hrpFormData?.severe_anaemia_treatment?.value
      ) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'fetalMalpresentation') {
      if (hrpFormData?.selectedHrp?.value) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'rhNegativeBloodGroup') {
      if (hrpFormData?.selectedHrp?.value) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'obstraticHistory') {
      if (
        hrpFormData?.selectedHrp?.value &&
        hrpFormData?.selectedHrp?.value?.length > 0
      ) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'otherHighRiskSymptoms') {
      if (
        hrpFormData?.selectedHrp?.value &&
        hrpFormData?.selectedHrp?.value?.length > 0
      ) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'gestationalDiabetesMellitus') {
      if (hrpFormData?.selectedHrp?.value) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'underWeight') {
      if (
        hrpFormData?.weight_in_kg?.value &&
        !ObstetricHistoryCheck('weight', hrpFormData?.weight_in_kg?.value) &&
        isValueContainsOnlyDigits(hrpFormData?.weight_in_kg?.value)
      ) {
        return false;
      } else return true;
    }

    if (selectHRPType.hrp_key == 'shortStature') {
      if (
        hrpFormData?.height_in_cm?.value &&
        ObstetricHistoryCheck('shortStature', hrpFormData?.height_in_cm?.value) &&
        isValueContainsOnlyDigits(hrpFormData?.height_in_cm?.value)
      ) {
        return false;
      } else return true;
    }

    return false;
  };

  const closeHrpConditionModal = () => {
    setSelectHRPType(null);
    setHrpFormData(null);
    setHrpServiceData(null);
    setShowHRPConditionModal(false);
  };

  const handleHrpConditionFormBackButton = () => {
    setShowHRPConditionForm(false);
    setShowHRPConditionModal(true);
    setSelectHRPType(null);
    setHrpFormData(null);
    setHrpServiceData(null);
  };

  const handleCloseWarningModal = () => {
    setShowWarningModal(false);
    closeHrpConditionModal();
  };

  const handleWarningModalBackButton = () => {
    setShowWarningModal(false);
    setShowHRPConditionForm(true);
  };

  const getFormBasicDetails = (tempForm: any) => {
    const payload: any = {};
    payload['hrp_code'] = tempForm?.hrp_code;
    payload['hrp_id'] = tempForm?.hrp_id;
    payload['report_code'] = tempForm?.report_code;
    payload['report_id'] = tempForm?.report_id;
    payload['report_name'] = tempForm?.report_name;
    payload['service_code'] = tempForm?.service_code;
    payload['service_id'] = tempForm?.service_id;
    payload['report'] = tempForm?.report;

    return payload;
  };

  const prepareData = (hrpFormData: any) => {
    const payloadData: any = [];

    const dateKeys = Object.keys(hrpFormData)?.filter(
      (key: any) => hrpFormData[key].isDate,
    );

    const inputKeys = Object.keys(hrpFormData)?.filter(
      (key: any) => !dateKeys?.includes(key),
    );

    inputKeys?.forEach((key: any) => {
      const record = { ...hrpFormData[key] };

      if (record?.isMultiple == true || record?.isSingleDropdown == true) {
        //If value is single or multiselect
        let values = hrpFormData[key].value;
        if (record?.isSingleDropdown == true) values = [hrpFormData[key].value];

        values?.forEach((el: any) => {
          const record = hrpServiceData?.find(
            (hrp: any) => hrp?.report_id == el?.value,
          );
          payloadData.push({ ...getFormBasicDetails(record) });
        });
      } else {
        if (
          !record?.report_id ||
          record?.report_id == '' ||
          record?.report_id == null
        ) {
          record['report'] = record.value;
          payloadData.push({ ...getFormBasicDetails(record) });
        }
      }
    });

    //Add date to the respective service
    if (dateKeys?.length > 0) {
      dateKeys?.forEach((key: any) => {
        payloadData?.forEach((el: any, index: number) => {
          if (el.service_code == hrpFormData[key]?.service_code) {
            payloadData[index] = {
              ...el,
              service_date: hrpFormData[key].value,
            };
          }
        });
      });
    }

    return payloadData;
  };

  const getANCData = async (pregnancyId: any) => {
    const pregnancyDetails = await getData<any>(`${endpoints.getPregnancyHistory(benefId)}`);
    const onGoingPregnancy = pregnancyDetails.data.find((data: any) => data.delivery_status === 'on going');
    const ongoingPregnancyDetails = await getData<any>(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
    
    const { anc, endDate, startDate } = getOngoingANCNumber(ongoingPregnancyDetails.data[0]?.lmp, FormatDate(facilityDetails?.visitDate))
    
    return { ancNumber: anc, startDate, endDate };
  };
  const prepareSevereAnemiaData = (data: any) => {
    const hbgmData = data?.find(
      (el: any) => el?.hrp_code == 'hb_severe_anaemia',
    );
    const treatment = data?.find((el: any) => el?.report_code);
    const payloadData = {
      hbGmServiceId: hbgmData?.service_id,
      hbGmReport: hbgmData?.report,
      hbGmHrpId: hbgmData?.hrp_id,
      severeAnemiaTreatmentServiceId: treatment?.service_id,
      severeAnemiaTreatmentReportId: treatment?.report_id,
      severeAnemiaTreatmentReportCode: treatment?.report_code,
      severeAnemiaTreatmentReportName: treatment?.report_name,
      severeAnemiaTreatmentServicecode: treatment?.service_code,
      serviceCode: hbgmData?.service_code,
    };

    return payloadData;
  };

  const handleFinalProceed = async () => {
    let apiEndpoint;
    const isMultiValueHrp = [
      'obstraticHistory',
      'otherHighRiskSymptoms',
    ]?.includes(selectHRPType?.hrp_key);

    const serviceDetailsRaw = prepareData(hrpFormData);
    const serviceDetails = serviceDetailsRaw.map((item:any)=>({
      ...item,
      ...(item.report_name ? 
        {report_name : 
          (item.report_name.includes('>')? item.report_name.replace('>', 'gt_') 
          : (item.report_name.includes('<') ? item.report_name.replace('<', 'lt_') 
          : item.report_name))
        }
        : {})
    }))
    const { ancNumber, startDate, endDate } = await getANCData(
      onGoingPregnancyData?.pregnancyId,
    );
    try {
      let payload: any = {
        benefId: benefId,
        pregnancyId: onGoingPregnancyData
          ? onGoingPregnancyData.pregnancyId
          : '',
        ancNo: ancNumber,
        ancServiceStartDt: FormatDate(startDate),
        ancServiceEndDt: FormatDate(endDate),
        serviceDt: FormatDate(new Date()),
        ancServiceDt: FormatDate(new Date()),
        hrpType: selectHRPType.hrp_key,
        facilityId:facilityDetails?.facilityId,
        healthProviderId: facilityDetails?.healthProviderId,
        mobiliserId:  facilityDetails?.mobilizerId || null,
        visitDate: FormatDate(facilityDetails?.visitDate),
        processChannel: 'web'
      };

      if (selectHRPType.hrp_key == 'severeAnemia') {
        apiEndpoint = endpoints?.createHRPConditionSevereAnemia;
        const anemiaData = prepareSevereAnemiaData(serviceDetails);
        payload = { ...payload, ...anemiaData };
      } else {
        apiEndpoint = endpoints.createHRPCondition;
        payload['serviceDetails'] = serviceDetails;
        payload['serviceDt'] = FormatDate(new Date());
        payload['ancServiceDt'] = FormatDate(new Date());
      }
      if (isMultiValueHrp) {
        payload['serviceId'] = payload?.serviceDetails[0].service_id;
        payload['serviceDetails'] = payload?.serviceDetails?.map((el: any) => {
          delete el.service_id;
          return el;
        });
      }
      setIsLoading(true);
      const response: any = await postDataJSON<any>(`${apiEndpoint}`, payload);
      if (response) {
        handleCloseWarningModal();
        toast.success('Hrp condition added successfully.', {
          position: 'top-center',
        });
        dispatch(setCheckIsHrp(!checkIsHRP))
        getBeneficiaryHRPCondtionsDetails(onGoingPregnancyData.pregnancyId);

      }
    } catch (error: any) {
      toast.error(error?.message, {
        position: 'top-center',
      });
    } finally {
      setIsLoading(false);
    }
  };
 const onClickAddHRPCondition=()=>{
  if(!benfDetails[0]?.is_dead){
    setShowFacilityDetails(true)
  //  navigate('/beneficiaries/hrp/service');
      // setShowHRPConditionModal(true);
      // setHrpFormData(null);
  }
 }
 const onCancelFacilityDetails=()=>{
  setShowFacilityDetails(false) 
 }

 const onSubmitFacilityDetails=(data:any)=>{
  setFacilityDetails(data);
  setShowFacilityDetails(false) ;
  setShowHRPConditionModal(true);
  setHrpFormData(null);
 }
 
  const getHRPTooltip = (hrpName: string, isFirstPreg: boolean) => {
    if (hrpName === ANC_SUB_SERVICE.OBSETETRIC_HISTORY && isFirstPreg) {
      return HRP_ERROR_MESSAGES.HRP_NOT_APPLICABLE(hrpName);
    }
    return HRP_ERROR_MESSAGES.HRP_ALREADY_EXISTS(hrpName);
  };

  return (
    <>{showFacilityDetails ?<HRPFacilityDetails 
      onCancelFacilityDetails={onCancelFacilityDetails} 
      onSubmitFacilityDetails={onSubmitFacilityDetails}
      onGoingPregnancyData={onGoingPregnancyData}
    /> :<div>
      {!selectedHrpData ? (
        <div className="hrp_user_main">
          <div className="show_scanner">
            <div className="show_scanner_details">
              <BadgesComponent
                className="over-badge"
                badgeName="HRP Conditions"
                variant="primary-1"
                badgeType="case5"
              />
            </div>
            {onGoingPregnancyData?.pregnancyId &&
              <div className="show_header_btn_modal">
                 {userRole!== COMMON_CONSTANTS.FIELD_LEVEL_USER && (
                <ButtonModal
                  onClick={onClickAddHRPCondition}
                  id="add-beneficiary"
                  buttonName={buttonNames.HRPCondition}
                  disabled={benfDetails[0]?.is_dead}
                  colorType={'primary'}
                  iconPosition={'left'}
                  icon={<PlusSvgIcon />}
                />
              )}
              </div>}

          </div>
          <div className="overview_details">
            {isLoading ? <div className='loader'>Loading...</div>:
            hrpConditionsData?.length > 0 ? hrpConditionsData?.map((item: any) => (
              <Card
                className="overview_details_card"
                key={item.hrp_condition_name}
                onClick={() => handleRowClick(item)}
              >
                <Card.Body className="overview_details_card_body">
                  <Card.Subtitle>{item.hrp_name}</Card.Subtitle>
                  <Card.Text>
                    <BadgesComponent
                      className="over-badge"
                      badgeName={item?.treatment_status_name}
                      badgeType="case7"
                      variant={item.treatment_status_name[0] !== "Treated" ? "info" : "success"}
                    />
                  </Card.Text>
                </Card.Body>
              </Card>
            )) : <div style={{ backgroundColor: '#8080802b', height: '90px', padding: '10px', width: '600px' }}>
              No HRP condition linked to Beneficiary Profile
            </div>}
          </div>
        </div>
      ) : isLoading ? (
        <div style={{ textAlign: 'center' }}>
          <span>Loading...</span>
          <Spinner />
        </div>
      ) : (
        <HRPHistory
          hrpData={selectedHrpData}
          handleRowClick={handleRowClick}
          isLoading={isLoading}
          setSelectedHrpData={setSelectedHrpData}
        />
      )}

      <>
        <CommonModal
          show={showHRPConditionModal}
          handleClose={closeHrpConditionModal}
          handleCustomBackButton={closeHrpConditionModal}
          conditionalClass="modal_component"
          showCustomHeader={true}
          title=""
          size="md"
          showfooter={false}
        >
          <>
            <div className="hrp_condition_container">
              <h1 className="modal_head_text" style={{ marginBottom: '15px' }}>
                HRP Conditions
              </h1>
              <h3 className="modal_body_text" style={{ marginBottom: '15px' }}>
                Choose HRP Condition
              </h3>
              <div className="hrp_condition_list">
                {hrpConditionList?.map((hrp: any) => (
                  <div
                    key={hrp.hrp_name}
                    className={`hrp-service-modal-data ${hrpConditionDisableList.includes(hrp.hrp_name) ? 'disable' : ''}`}
                    onClick={() => handleHRPTypesClick(hrp)}
                  >
                    <div className={`hrp-service-modal-icon ${hrpConditionDisableList.includes(hrp.hrp_name) ? 'disable' : ''}`}>
                      <span className="clock_icon">
                        <Clock />
                      </span>
                      <p className="hrp_name">{hrp.hrp_name}</p>
                    </div>
                    <span className={`plus_icon ${hrpConditionDisableList.includes(hrp.hrp_name) ? 'disable' : ''}`}>+</span>
                    {hrpConditionDisableList.includes(hrp.hrp_name) ? <span className="tooltiptext">
                      {getHRPTooltip(hrp.hrp_name, !!onGoingPregnancyData?.is_first_preg)}
                    </span> : <></>}
                  </div>
                ))}
              </div>
            </div>
          </>
        </CommonModal>
      </>
      {showHRPConditionForm && (
        <CommonModal
          show={showHRPConditionForm}
          handleClose={() => closeHRPConditionTypesModal('')}
          handleCustomBackButton={handleHrpConditionFormBackButton}
          conditionalClass="modal_component dynamic_form_field"
          showCustomHeader={true}
          title=""
          size="md"
          footer={
            <>
              <ButtonModal
                onClick={() => closeHRPConditionTypesModal('yes')}
                id="cancel"
                buttonName={'Next'}
                colorType={'secondary'}
                disabled={isHrpConditionFormNextBtnDisabled()}
              />
            </>
          }
        >
          <AllHRPForms
            hrpServiceData={hrpServiceData}
            {...(hrpServiceData?.[0]?.service_code == "obstetric_history" &&
              { disableOptions: hrpObsetricHistoryDisableList })}
            selectedHRp={selectHRPType}
            hrpType={selectHRPType?.hrp_name}
            formData={hrpFormData}
            setFormData={(formData: any) => {
              setHrpFormData(formData);
            }}
          />
        </CommonModal>
      )}
      {showWarningModal && (
        <HRPWarningModal
          handleCloseModal={handleCloseWarningModal}
          hrpType={selectHRPType?.hrp_name}
          showWarningModal={showWarningModal}
          handleWarningModalBackButton={handleWarningModalBackButton}
          handleFinalProceed={handleFinalProceed}
        />
      )}
    </div>}</>
  );
};
export default HRPTracking;
